import { Helmet } from "react-helmet-async";

const SITE_URL = "https://centroderehabilitaciondedrogas.cl";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;
const SITE_NAME = "Centro de Rehabilitación de Drogas Chile";

export default function Seo({
    title,
    description,
    path = "/",
    image = DEFAULT_IMAGE,
    type = "website",
    keywords,
    jsonLd,
    noindex = false,
}) {
    const fullTitle = title
        ? `${title} | ${SITE_NAME}`
        : "Centro de Rehabilitación de Drogas en Chile | Directorio Verificado";
    const canonical = `${SITE_URL}${path}`;
    const robots = noindex
        ? "noindex, nofollow"
        : "index, follow, max-image-preview:large, max-snippet:-1";

    return (
        <Helmet>
            <html lang="es-CL" />
            <title>{fullTitle}</title>
            {description ? <meta name="description" content={description} /> : null}
            {keywords ? <meta name="keywords" content={keywords} /> : null}
            <meta name="robots" content={robots} />
            <meta name="googlebot" content={robots} />

            <link rel="canonical" href={canonical} />
            <link rel="alternate" hrefLang="es-CL" href={canonical} />
            <link rel="alternate" hrefLang="es" href={canonical} />
            <link rel="alternate" hrefLang="x-default" href={canonical} />

            <meta property="og:type" content={type} />
            <meta property="og:locale" content="es_CL" />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={fullTitle} />
            {description ? <meta property="og:description" content={description} /> : null}
            <meta property="og:url" content={canonical} />
            <meta property="og:image" content={image} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:image:alt" content={fullTitle} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            {description ? <meta name="twitter:description" content={description} /> : null}
            <meta name="twitter:image" content={image} />

            {jsonLd ? (
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            ) : null}
        </Helmet>
    );
}
